import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, switchMap} from 'rxjs/operators';
import {map, of} from 'rxjs';
import {CompanyService} from '../../../services/company-service/company.service';
import {CompanyPageActions, MyCompanyActions} from '../actions/company.actions';
import { HttpStatusCode } from '@angular/common/http';

@Injectable()
export class CompanyEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly companyService: CompanyService
  ) {
  }

  loadCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MyCompanyActions.load),
      switchMap(({companyName}) =>
        this.companyService.getCompany(companyName).pipe(
          map((company) => MyCompanyActions.loaded({company})),
          catchError((error) => {
              if (error === HttpStatusCode.NotFound) {
                return of(MyCompanyActions.notFound());
              } else {
                return of(MyCompanyActions.errorLoading(error));
              }
            }
          ))));
  });

  loadCompanyPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyPageActions.load),
      switchMap(({companyId}) => {
          return this.companyService.getCompanyPage(companyId).pipe(
            map((companyPage) => {
              return CompanyPageActions.loaded({companyPage});
            }),
            catchError((error) => of(CompanyPageActions.errorLoading(error)))
          );
        }
      )
    )
  );

}
